module.exports = __webpack_public_path__ + "static/img/p_02.52c76bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/p_02.jpg
// module id = V6/K
// module chunks = 9